export default "__VITE_ASSET__CUaO8yNN__"